<div id="relatorio-guias" class="container-fluid">
    <h3>Contagens de Inventário</h3>
    <mat-card>
        <mat-card-header class="header-padrao">
            <mat-card-title>
                <form class="filtros-header" [formGroup]="inventarioForm">
                    <div class="header-filter-log">
                        <div class="row" style="display: inherit;">

                            <div class="row">
                                <mat-form-field class="example-full-width">
                                    <mat-label>Número </mat-label>
                                    <input matInput class="number" type="text" [disableControl]="true"
                                        formControlName="numero">
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <mat-label>Agente </mat-label>
                                    <input matInput type="text" [disableControl]="true" formControlName="agente">
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <mat-label>Status </mat-label>
                                    <input matInput type="text" [disableControl]="true" formControlName="status">
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Data de Criação</mat-label>
                                    <input matInput autocomplete="off" [matDatepicker]="dataFinal" [disableControl]="true"
                                        formControlName="dtCriacao">
                                    <mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
                                    <mat-datepicker #dataFinal></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <mat-label>Criado Por </mat-label>
                                    <input matInput type="text" [disableControl]="true" formControlName="criadoPor">
                                </mat-form-field>

                            </div>

                            <!-- AQUI -->
                            <div class="row">
                                <mat-form-field>
                                    <mat-label>Data de Autorização (Início)</mat-label>
                                    <input matInput autocomplete="off" [matDatepicker]="dtAutInicioGestor"
                                        [disableControl]="true" formControlName="dtAutInicioGestor">
                                    <mat-datepicker-toggle matSuffix [for]="dtAutInicioGestor"></mat-datepicker-toggle>
                                    <mat-datepicker #dtAutInicioGestor></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <mat-label>Autorizado Por (Início) </mat-label>
                                    <input matInput type="text" [disableControl]="true"
                                        formControlName="usuarioGestorAutInicio">
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Data de Autorização (Finalização)</mat-label>
                                    <input matInput autocomplete="off" [matDatepicker]="dtAutFinGestor"
                                        [disableControl]="true" formControlName="dtAutFinGestor">
                                    <mat-datepicker-toggle matSuffix [for]="dtAutFinGestor"></mat-datepicker-toggle>
                                    <mat-datepicker #dtAutFinGestor></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <mat-label>Autorizado Por (Finalização) </mat-label>
                                    <input matInput type="text" [disableControl]="true" formControlName="usuarioGestorAutFin">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-card-title>
            <div style="display: block">
                <button class="voltar" mat-raised-button color="primary" matTooltip="Voltar" (click)="voltar()">
                    <i class="fas fa-arrow-circle-left"></i> Voltar
                </button>
                <!-- AQUI -->
                <div class="action-buttons">

                    <button mat-icon-button class="notification-add-button cursor-pointer-icon"
                        (click)="createInventarioContagem();" matTooltip="Nova Contagem"
                        [disabled]="inventario.statusId !==2 || existsContagemAberta()">
                        <mat-icon fontSet="fas" fontIcon="fa-plus"></mat-icon>
                    </button>

                    <button mat-icon-button class="notification-add-button cursor-pointer-icon" (click)="search();"
                        matTooltip="Atualizar contagens">
                        <mat-icon fontSet="fas" fontIcon="fa-undo"></mat-icon>
                    </button>
                </div>
            </div>

        </mat-card-header>

        <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
        <mat-card-content class="no-padding">
            <div>
                <div>
                    <table #table id="event-table" mat-table [dataSource]="inventarioContagemCapaCollection"
                        class="table-sm">
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Opções</th>
                            <td mat-cell *matCellDef="let item">
                                <button mat-icon-button [matMenuTriggerFor]="menu"
                                    aria-label="Example icon-button with a menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item color="primary"
                                        (click)="efetuarContagem(item.inventarioContagemId)"
                                        [disabled]="item.inventarioContagemStatusId !== 1">
                                        Efetuar Contagem
                                    </button>

                                    <button mat-menu-item color="primary"
                                        (click)="encerrarContagem(item.inventarioContagemId)"
                                        [disabled]="item.inventarioContagemStatusId !== 1">
                                        Fechar Contagem
                                    </button>

                                    <button mat-menu-item color="primary"
                                        (click)="cancelarContagem(item.inventarioContagemId)"
                                        [disabled]="item.inventarioContagemStatusId !== 1">
                                        Cancelar Contagem
                                    </button>

                                    <button mat-menu-item color="primary"
                                        (click)="openModalExibirContagens(item)"
                                        [disabled]="item.inventarioContagemStatusId !== 3">
                                        Exibir Dados da Contagem
                                    </button>
<!--
                                    <button mat-menu-item color="primary"
                                        (click)="openModalExibirResumoPorStatus(item)"
                                        [disabled]="item.inventarioContagemStatusId !== 3">
                                        Exibir Resumo por Status
                                    </button> -->
                                </mat-menu>
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="numeroContagem">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Contagem</th>
                            <td mat-cell *matCellDef="let item" class="text-center" class="description">
                                {{ item.numeroContagem }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dtCriacao">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Data de Criação</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.dtCriacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="criadoPor">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Criado Por</th>
                            <td mat-cell *matCellDef="let item; let index = index;" class="text-center">
                                {{ item.criadoPor }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dtEncerramento">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Data de Encerramento</th>
                            <td mat-cell *matCellDef="let item" class="text-center">
                                {{ item.dtEncerramento | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="encerradoPor">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Encerrado Por</th>
                            <td mat-cell *matCellDef="let item; let index = index;" class="text-center">
                                {{ item.encerradoPor }}</td>
                        </ng-container>

                        <ng-container matColumnDef="qtdPedidos">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Qtd. Pedidos</th>
                            <td mat-cell *matCellDef="let item; let index = index;" class="text-center">
                                {{ item.qtdPedidos }}</td>
                        </ng-container>

                        <ng-container matColumnDef="qtdVolume">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Qtd. Volume</th>
                            <td mat-cell *matCellDef="let item; let index = index;" class="text-center">
                                {{ item.qtdVolume }}</td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
                            <td mat-cell *matCellDef="let item; let index = index;" class="text-center">
                                {{ item.status }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <div *ngIf="!isLoading && inventarioContagemCapaCollection?.data?.length === 0"
                    class="d-flex justify-content-center align-items-center" style="height: 100px;">
                    Nenhum registro para o período!
                </div>
            </div>

        </mat-card-content>
    </mat-card>
</div>
